import React from "react";
import {
  ActionIcon,
  Group,
  Text,
  Combobox,
  useCombobox,
  ScrollArea,
} from "@mantine/core";
import { IconX, IconWorld } from "@tabler/icons-react";
import { useState, useMemo } from "react";
import { defaultTimeZone } from "../../utils/timeZones";
import { useTimeZone } from "./useTimeZone";
import { shortenText } from "../../utils/formatter";
import styles from "./TimeZoneSelect.module.scss"

export function TimeZoneDesktop() {
  const { options, current, selectTimeZone, resetTimeZone } = useTimeZone();
  const combobox = useCombobox();


  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    if (!query.trim()) return options;
    return options.filter((tz) =>
      tz.city.toLowerCase().includes(query.toLowerCase())
    );
  }, [query, options]);

  return (
    <Combobox
      store={combobox}
      onOptionSubmit={(value) => {
        selectTimeZone(value);
        combobox.closeDropdown();
        setQuery("");
      }}
    >
      <Combobox.Target>
        <Group
          gap={2}
          style={{
            border: "1px solid var(--mantine-color-gray-4)",
            borderRadius: 8,
            padding: "4px 10px",
            background: "white",
            cursor: "text",
            transition: "all 0.15s ease",
            minWidth: 170,
            position: "relative",
          }}
          onClick={() => combobox.openDropdown()}
        >
          <IconWorld className={styles.icon} />

          <input
            type="text"
            placeholder={
              current
                ? `${shortenText(current.city, 10)} ${current.utc}`
                : "Select timezone"
            }
            value={query}
            onChange={(e) => {
              setQuery(e.currentTarget.value);
              combobox.openDropdown();
            }}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              background: "transparent",
              color: "var(--brand-color)",
              fontWeight: 500,
              fontSize: 14,
              maxWidth: 130,
              textAlign: "center",
              marginRight: current?.value !== defaultTimeZone ? 10 : 10, // prostor za X
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          />

          {current?.value !== defaultTimeZone && (
            <ActionIcon
              size="sm"
              variant="transparent"
              onClick={(e) => {
                e.stopPropagation();
                resetTimeZone();
                setQuery("");
                combobox.closeDropdown();
              }}
              style={{
                color: "var(--brand-color)",
                position: "absolute",
                right: 5,
                cursor: "pointer",
                opacity: 0.6,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.6")}
            >
              <IconX className={styles.icon} />
            </ActionIcon>
          )}
        </Group>
      </Combobox.Target>

      <Combobox.Dropdown style={{ minWidth: 220 }}>
        <ScrollArea.Autosize mah={200}>
          <Combobox.Options>
            {filtered.length > 0 ? (
              filtered.map((tz) => (
                <Combobox.Option style={{fontSize: 14}} value={tz.value} key={tz.value}>
                  <Group justify="space-between">
                    <Text>{tz.label}</Text>
                  </Group>
                </Combobox.Option>
              ))
            ) : (
              <Combobox.Empty>No results found</Combobox.Empty>
            )}
          </Combobox.Options>
        </ScrollArea.Autosize>
      </Combobox.Dropdown>
    </Combobox>
  );
}
